import { Injectable } from '@angular/core';
import { CategoriaVeiculo } from '@tivic-team/manager-ts/dist/fta/entities/categoria-veiculo.entity';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';


@Injectable()
export class CategoriaVeiculoController {

    constructor() { }

    async get(cdCategoria: number): Promise<CategoriaVeiculo> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'fta/veiculo/categorias/:cdCategoria',
                    environment: environment,
                    pathParams: new JSONData({ cdCategoria: cdCategoria })
                }),
            }),
            new HttpResponse(
                new CategoriaVeiculo()
            )
        );
        return await quark.call();
   }
    async getAll(): Promise<Array<CategoriaVeiculo>> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'fta/veiculo/categorias',
                    environment: environment,
                }),
            }),
            new HttpResponse(
                new Array<CategoriaVeiculo>()
            )
        );
        return await quark.call();
    }

    async find(filtros?: IFilter): Promise<Array<CategoriaVeiculo>> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'fta/veiculo/categorias',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<CategoriaVeiculo>()
            )
        );
        return await quark.call();
    }

    async create(categoriaVeiculo: CategoriaVeiculo): Promise<CategoriaVeiculo> {

        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'fta/veiculo/categorias',
                    environment: environment,
                }),
                data: new JSONData(categoriaVeiculo)
            }),
            new HttpResponse(
                new CategoriaVeiculo()
            )
        );
        return await quark.call();
    }

    async update(categoriaVeiculo: CategoriaVeiculo): Promise<CategoriaVeiculo> {
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'fta/veiculo/categorias/:cdCategoria',
                    environment: environment,
                    pathParams: new JSONData({ cdCategoria: categoriaVeiculo.cdCategoria })
                }),
                data: new JSONData(categoriaVeiculo)
            }),
            new HttpResponse(
                new CategoriaVeiculo()
            )
        );
        return await quark.call();
    }
}